import { FC } from 'react'

interface PermissionsToolbarProps {
  selectedCount: number
  totalCount: number
  onSelectAll: () => void
  isAllSelected: boolean
}

export const PermissionsToolbar: FC<PermissionsToolbarProps> = ({
  selectedCount,
  totalCount,
  onSelectAll,
  isAllSelected,
}) => {
  return (
    <div className='d-flex justify-content-between align-items-center mb-3 pb-3 border-bottom'>
      <button className='btn btn-outline-secondary btn-sm' onClick={onSelectAll}>
        {isAllSelected && totalCount > 0
          ? 'Desselecionar Todos'
          : 'Selecionar Todos'}
      </button>
      <span className='text-muted small'>
        {selectedCount} de {totalCount} selecionadas
      </span>
    </div>
  )
}
